import { Breadcrumbs } from "components/breadcrumbs";
import { CreateSupportCategoryForm } from "./components";

export const CreateSupportCategory: React.FC = () => {

  return (
    <div className="wrapper">
      <Breadcrumbs customPageLabel="Create Support Center Category" />
      <CreateSupportCategoryForm />
    </div>
  );
};
